import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import { useQuery } from '@apollo/client';
import {GET_SUGGESTED_STEPS} from '../apis/graphqlQueries';
// import ListItemText from '@mui/material/ListItemText';
// import ListItem from '@mui/material/ListItem';
// import List from '@mui/material/List';
// import Typography from '@mui/material/Typography';
// import LinearProgress from '@mui/material/LinearProgress';
// import Grid from '@mui/material/Grid';
// import Item from '@mui/material/Grid';
// import PrintPage from '../common/print_page';

import Typography from '@mui/material/Typography'
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';

import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';

import Box from '@mui/material/Box';
import useDrawerHistory from '../hooks/useDrawerHistory';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AssistantDialog = ({ viewAssistant, setviewAssistant, assistantSteps }) => {

  // Manage browser history for back button behavior
  useDrawerHistory(viewAssistant, () => setviewAssistant(false), 'assistant-dialog');

  return (
    <div>
      <Dialog
        fullScreen
        open={viewAssistant}
        onClose={() => { }}
        TransitionComponent={Transition}>
        <AppBar position="sticky">
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => setviewAssistant(false)}
              aria-label="close"
            >
            <CloseIcon />
            </IconButton>
            AI based assistant |  
          </Toolbar>
        </AppBar>
        <Box sx={{ flexGrow: 1, padding: 3 }} >
        <Typography
            variant="body1" 
            gutterBottom
            style={{whiteSpace: "pre-line"}}
            >{assistantSteps}</Typography>
        </Box>
      </Dialog>

    </div>
  );
}

export default AssistantDialog 